/* global $:false */

import MarketLotIndexCountdown from 'src/public/market_lot_index_countdown.js'
import PusherClient from 'src/shared/pusher_client.js'

export default class MarketLotIndexLot {
  static init () {
    this.lots = []

    for (const el of Array.from($('.js-market-lot-index-lot'))) {
      this.lots.push(new MarketLotIndexLot(el))
    }

    if (this.lots.length) { this.subscribeToUpdates() }
  }

  static subscribeToUpdates () {
    const channel = PusherClient.connection().subscribe('lot-bids')

    channel.bind('bid', event => {
      const lot = this.findLot(event.real_lot_id)
      if (lot) { lot.update(event) }
    })

    channel.bind('expired', event => {
      const lot = this.findLot(event.lot_id)
      if (lot) { lot.expire() }
    })
  }

  static findLot (lotId) {
    for (const lot of this.lots) {
      if (`${lotId}` === `${lot.lotId}`) { return lot }
    }
  }

  constructor (el) {
    this.el = $(el)
    this.readDataAttributes()
    this.findElements()
    this.start()
  }

  readDataAttributes () {
    this.lotId = this.el.attr('data-lot-id')
    this.endDate = this.el.attr('data-end-date')
  }

  findElements () {
    this.countdown = new MarketLotIndexCountdown(this.el)
    this.resultContainer = this.el.find('.js-market-lot-index-lot__result')
  }

  start () {
    this.countdown.start(this.endDate)
  }

  update (message) {
    if (!message.bidding_end_date) { return }
    this.endDate = message.bidding_end_date
    this.countdown.update(this.endDate)
    this.resultContainer.replaceWith(message.result_component)
  }

  expire () {
    this.countdown.expire()
    this.el.fadeTo('slow', 0.5)
  }
}
